import { render, staticRenderFns } from "./Leader.vue?vue&type=template&id=26c58f8c&scoped=true&"
import script from "./Leader.vue?vue&type=script&lang=js&"
export * from "./Leader.vue?vue&type=script&lang=js&"
import style0 from "./Leader.vue?vue&type=style&index=0&id=26c58f8c&scoped=true&lang=css&"
import style1 from "../../constant/css/detail.css?vue&type=style&index=1&id=26c58f8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c58f8c",
  null
  
)

export default component.exports